<template>
  <section class="pin__menu" v-touch:swipe.down="close">
    <div class="rule">
      <img src="../assets/icons/pindetail/line.png" alt="rule" />
    </div>
    <div class="top-row">
      <div class="flex-center">
        <img
          v-if="name === 'Me'"
          class="battery low"
          src="../assets/icons/pindetail/battery-low.png"
          alt="battery"
        />
        <img
          v-else-if="name === 'Sam Morris'"
          class="battery low"
          src="../assets/icons/pindetail/battery-half.png"
          alt="battery"
        />
        <img
          v-else
          class="battery"
          src="../assets/icons/pindetail/battery.png"
          alt="battery"
        />
        <span v-if="name === 'Sam Morris'">47%</span>
        <span v-else-if="name === 'Me'">15%</span>
        <span v-else>95%</span>
      </div>
      <section class="info">
        <span>Just Now</span>
      </section>
    </div>
    <h1>{{ name }}</h1>
    <div>
      <p>
        <span class="near">Near</span>
        <strong v-html="address"></strong>
        <span class="near" v-if="name === 'Erica Morris'"
          >Since 9:30am | 8.2 mi away</span
        >
        <span v-else-if="name === 'Me'"></span>
        <span class="near" v-else>Since 8:30am | 35.7 mi away</span>
      </p>
    </div>
    <div class="bottom-row" v-if="name !== 'Me'">
      <span v-if="name === 'Erica Morris'" class="nav-button" @click="navRoute">
        <img src="../assets/icons/pindetail/nav.png" alt="nav icon" />
      </span>
      <span v-else class="nav-button" @click="navRouteAA">
        <img src="../assets/icons/pindetail/nav.png" alt="nav icon" />
      </span>
      <span class="call-button" @click="openCallScreen(name)">
        <img src="../assets/icons/pindetail/phone.png" alt="call icon" />
      </span>
      <span class="txt-button" @click="navText(name)">
        <img src="../assets/icons/pindetail/txt.png" alt="text icon" />
      </span>
    </div>
  </section>
</template>

<script>
export default {
  name: "PinDetail",
  props: {
    close: Function,
    name: String,
    address: String,
  },
  methods: {
    openCallScreen(name) {
      this.close()
      this.$router.push({ path: `call/${name}` })
    },
    navRoute() {
      this.close()
      this.$router.push("nav")
    },
    navRouteAA() {
      this.close()
      this.$router.push("nav-annarbor")
    },
    navText(name) {
      this.close()
      this.$router.push({ path: `text/${name}` })
    },
  },
}
</script>

<style lang="scss" scoped>
.pin__menu {
  color: #fff;
  background-color: #202633;
  position: absolute;
  bottom: 4%;
  left: 0;
  display: flex;
  flex-direction: column;
  border-radius: 20px 20px 0 0;
  align-items: left;
  text-align: left;
  max-height: 70%;
  font-size: 1.5rem;
  min-width: 80%;
  max-width: 80%;
  z-index: 10;
  transform: translateY(+150%);
  transition: all 300ms ease-in-out;
  margin: 0;
  padding: 0 10%;

  @media only screen and (max-height: 800px) {
    bottom: 6.75%;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0.25rem 0;

    p {
      width: 80%;
      margin-top: 0;
    }

    img {
      width: 30px;
      height: 30px;
      align-items: right;
    }
  }
  h1 {
    font-size: 2.25rem;
  }

  .flex-center {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.25rem;
  }

  .info {
    display: flex;
    flex-direction: column;
    color: #39b6ff;
    font-size: 1.25rem;
  }

  .near {
    display: block;
    font-size: 1.25rem;
  }

  .top-row {
    display: flex;
    align-items: center;
  }

  .add-margin {
    margin-top: 2%;
  }

  .bottom-row {
    margin-bottom: 1rem;
  }

  h1 {
    margin: 0;
  }

  strong {
    margin-bottom: 20%;
  }

  .rule {
    justify-content: center;

    img {
      width: 50px;
      height: auto;
      margin: 0;
    }
  }

  .battery {
    width: auto;
    height: 2.75rem;
    padding: 1% 3% 0 0;
  }

  .pin {
    width: 28px;
    height: 28px;
    margin: 0 10px 5px 0;
  }

  .call-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border: 2px solid #21c97a;
    width: 25%;
    border-radius: 50px;
    padding: 0.5rem 0;

    img {
      height: auto;
      width: 50px;
    }
  }
  .txt-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #21c97a;
    border: 3px solid #21c97a;
    width: 25%;
    border-radius: 50px;
    padding: 0.5rem 0;

    img {
      height: auto;
      width: 50px;
    }
  }
  .nav-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2c72ff;
    width: 25%;
    border-radius: 50px;

    img {
      height: auto;
      width: 50px;
    }
  }

  .active & {
    transform: translateY(0%);
  }
}
</style>
